// holder for the routes and main view init settings
import Logger from '@yakit/core/logger'; let log = Logger(false);
import { writable, get } from 'svelte/store'
// import main from './main';
// import ipay from './ipay';
import common from './common';
import route404 from './404';

let _routes = []

/** sets the routes, called from  */
function setRoutes(newRoutes) {
  _routes = newRoutes
  isReady.set(true)
}

/**
 * Extracts all allowed route keys from the sidebar config
 * @param sidebarConfig - The sidebar configuration object
 * @returns Set of allowed route keys
 */
function getAllowedRouteKeys(sidebarConfig: any): Set<string> {
  const allowedKeys = new Set<string>()
  
  if (!sidebarConfig?.nav) return allowedKeys
  
  const nav = sidebarConfig.nav
  Object.keys(nav).forEach(key => {
    const navItem = nav[key]
    
    // If it has a direct route, add it
    if (navItem.route) {
      allowedKeys.add(navItem.route)
    }
    
    // If it has nested routes, add all of them
    if (navItem.routes && Array.isArray(navItem.routes)) {
      navItem.routes.forEach((route: any) => {
        if (route.key) {
          allowedKeys.add(route.key)
        }
      })
    }
  })
  
  return allowedKeys
}

/**
 * Filters routes based on allowed keys from sidebar config
 * Keeps child routes (*.show, *.new, etc.) if parent route is allowed
 * @param routes - All available routes
 * @param allowedKeys - Set of allowed route keys from sidebar
 * @returns Filtered routes array
 */
function filterRoutesByConfig(routes: any[], allowedKeys: Set<string>): any[] {
  return routes.filter(route => {
    if (route.notMenuItem) return true
    // Always allow routes without a name (shouldn't happen but safe)
    if (!route.name) return true
    
    // Check if this exact route is allowed
    if (allowedKeys.has(route.name)) return true
    
    // Check if this is a child route (e.g., 'ar.trans.show' when 'ar.trans' is allowed)
    const routeParts = route.name.split('.')
    // Check parent route(s)
    for (let i = routeParts.length - 1; i > 0; i--) {
      const parentRoute = routeParts.slice(0, i).join('.')
      if (allowedKeys.has(parentRoute)) {
        return true
      }
    }
    
    return false
  })
}

const isReady = writable(false)
const isViewReady = writable(false)
const routeByKey = (key: string): Record<string, any> => _routes.find(v => v.name === key)
const getPath = (key: string): string => routeByKey(key)?.path

// const common = async () => (await import('./common')).default()
//dynamic modules
const main = async () =>  (await import('./main')).default()
const ipay = async () =>  (await import('./ipay')).default()

const routesHolder = {
  /** store will be true when the routes are set */
  isReady,
  /** store will be true when main view is ready */
  isViewReady,
  /** gets the route for the key */
  routeByKey,
  /** gets the path for key*/
  getPath,

  // setupIpayRoutes: () => setRoutes([...common(), route404]),
  // FIXME getting ReferenceError: Cannot access 'injector' before initialization, dont get it.
  // setupIpayRoutes: () => setRoutes([...common(), ...ipay(), route404]),
  setupIpayRoutes: async (sidebarConfig?: any) => {
    const ipayRoutes = await ipay()
    let filteredRoutes = ipayRoutes
    
    if (sidebarConfig) {
      const allowedKeys = getAllowedRouteKeys(sidebarConfig)
      filteredRoutes = filterRoutesByConfig(ipayRoutes, allowedKeys)
      log("Filtered ipay routes based on permissions", { total: ipayRoutes.length, allowed: filteredRoutes.length })
    }
    
    setRoutes([...common(), ...filteredRoutes, route404])
  },

  setupRcmRoutes: async (sidebarConfig?: any) => {
    log("********** setupRcmRoutes")
    const mainRoutes = await main()
    let filteredRoutes = mainRoutes
    
    if (sidebarConfig) {
      const allowedKeys = getAllowedRouteKeys(sidebarConfig)
      filteredRoutes = filterRoutesByConfig(mainRoutes, allowedKeys)
      log("Filtered rcm routes based on permissions", { total: mainRoutes.length, allowed: filteredRoutes.length })
    }
    
    setRoutes([...common(), ...filteredRoutes, route404])
  },

  /** the routes for either ipay or rcm depending on what was setup */
  getRoutes: ():any[] => _routes,

  /** sets the routes, called from  */
  setRoutes: (newRoutes) => {
    _routes = newRoutes
    isReady.set(true)
  },
  /** gets the base common routes, the basics to log in */
  getCommonRoutes: () => {
    // const com = await common()
    return [...common(), route404]
  },
}

export default routesHolder

